import { initialState } from '../initial';
import { actionTypes } from '../actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CASHBACK_LIST_REQUEST:
    case actionTypes.CREATE_CASHBACK_REQUEST:
    case actionTypes.DELETE_CASHBACK_REQUEST:
      return {
        ...state,
        actionProcessing: true,
        error: null,
      };

    case actionTypes.GET_CASHBACK_LIST_SUCCESS:
      return {
        ...state,
        cashbackList: action.payload.items,
        cashbackCount: action.payload.count,
        skip: action.payload.skip,
        limit: action.payload.limit,
        actionProcessing: false,
        error: null,
      };

    case actionTypes.CREATE_CASHBACK_SUCCESS:
      return {
        ...state,
        actionProcessing: false,
        error: null,
      };

    case actionTypes.DELETE_CASHBACK_SUCCESS:
      return {
        ...state,
        actionProcessing: false,
        error: null,
      };

    case actionTypes.GET_CASHBACK_LIST_FAILURE:
    case actionTypes.CREATE_CASHBACK_FAILURE:
    case actionTypes.DELETE_CASHBACK_FAILURE:
      return {
        ...state,
        actionProcessing: false,
        error: action.payload,
      };

    case actionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case actionTypes.SET_ITEMS_ON_PAGE:
      return {
        ...state,
        itemsOnPage: action.payload,
      };

    default:
      return state;
  }
}
